import React from "react";
import "./NewsList.css";
import { ReactComponent as CheckIcon } from "../../assets/icons/check_icon.svg";

function NewsList({
  items = [],
  onSelect,
  onItemClick,       
  selectable = false,
  showCursor = false,
  next,
  previous,
  onNext,
  onPrevious,
  selectedItems = [],
}) {
  return (
    <div className="container-news-list">
      {items.length > 0 && (
        <div className="header-news-list">
          <p className="count-news-list">Apresentando {items.length} Notícias</p>

          {showCursor && (
            <div className="pagination-top-news-list">
              <button
                className="btn-news-list"
                onClick={onPrevious}
                disabled={!previous}
              >
                ← Anterior
              </button>
              <button
                className="btn-news-list"
                onClick={onNext}
                disabled={!next}
              >
                Próximo →
              </button>
            </div>
          )}
        </div>
      )}

      <div className="content-news-list">
        {items.length === 0 ? (
          <p className="empty-news-list">Nenhuma notícia encontrada.</p>
        ) : (
          items.map((news) => {
            const isSelected = selectedItems.includes(news.id);
            const categoriesText = Array.isArray(news.categories) && news.categories.length
              ? news.categories.map(c => c?.name).filter(Boolean).join(', ')
              : '-';
            return (
              <div
                key={news.id}
                className={`item-news-list ${selectable ? "selectable-news-list" : ""} ${
                  isSelected ? "selected-news-list" : ""
                }`}
                onClick={() => {
                  if (onItemClick) onItemClick(news.id, news);
                }}
              >
                <div className="left-news-list">
                  <p className="title-news-list">{news.title}</p>
                  <p className="meta-news-list">
                    {news.publish_date} | {news.source_detail?.source_type} | {news.source_detail?.name} |{" "}
                    {news.source_detail?.city?.name} - {news.source_detail?.city?.state} |{" "}
                    {categoriesText}
                  </p>
                </div>

                 {selectable && (
                  <div className="right-news-list">
                    <button
                      type="button"
                      className={`checkbox-news-list-btn ${isSelected ? "checked-news-list" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (onSelect) onSelect(news.id);
                      }}
                    >
                      {isSelected && <CheckIcon className="icon-news-list" />}
                    </button>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default NewsList;
